import { CommonModule } from '@angular/common';
import { Component, Inject, inject, OnInit } from '@angular/core';
import { ReactiveFormsModule, FormBuilder, Validators, FormGroup } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GenericObjectViewModel } from '../../../models/RES/genericObjectViewModel';
import { StatesService } from '../../../services/states.service';
import { VW_State } from '../../../models/RES/vwState';
import { CountriesService } from '../../../services/countries.service';
import { OccupationsService } from '../../../services/occupations.service';

// Translate
import { TranslateService, TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-add-personal-reference-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    ReactiveFormsModule,
    MatButtonModule,
    TranslatePipe
  ],
  templateUrl: './add-personal-reference-dialog.component.html',
  styleUrl: './add-personal-reference-dialog.component.scss'
})
export class AddPersonalReferenceDialogComponent implements OnInit {
  constructor(
    private fb: FormBuilder,
    public translate: TranslateService,
    private apiCountries: CountriesService,
    private apiStates: StatesService,
    private apiO: OccupationsService,
    private dialogRef: MatDialogRef<AddPersonalReferenceDialogComponent>,
    private _snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if(this.data.id){
      this.editMode = true;

      this.getStatesByCountry(this.data.countryId);

      this.Form = this.fb.group({
        id: [this.data.id],
        person_Id: [this.data.personId],
        firstName: [this.data.firstname, Validators.required],
        firstLastname: [this.data.firstlastname, Validators.required],
        secondLastname: [this.data.secondlastname, Validators.required],
        age: [this.data.age, Validators.required],
        occupation_Id: [this.data.occupationId, Validators.required],
        countryId: [this.data.countryId, Validators.required],
        state_Id: [this.data.stateId, Validators.required]
      });
    }else{
      this.editMode = false;

      this.Form = this.fb.group({
        id: [0],
        person_Id: [this.data.personId],
        firstName: ['', Validators.required],
        firstLastname: ['', Validators.required],
        secondLastname: ['', Validators.required],
        age: ['', Validators.required],
        occupation_Id: [0, Validators.required],
        countryId: ['', Validators.required],
        state_Id: [0, Validators.required]
      });
    }
  }
  editMode: boolean = false;

  countries: GenericObjectViewModel[] = [];
  states: VW_State[] = [];
  occupations: GenericObjectViewModel[] = [];

  Form: FormGroup;

  ngOnInit(): void {
    this.loadData();
  }

  loadData(){
    this.apiCountries.GetAllCountries().subscribe({
      next: (response) => {
        if (response.success === 1) {
          this.countries = response.data;
          this.apiO.GetAll().subscribe({
            next: (response) => {
              if (response.success === 1) {
                this.occupations = response.data;
              } else {
                this.openSnackBar(response.message);
              }
            },
            error: (error) => {
              const statusCode = error.status;
              const errorMessage = error.error?.message || "An error occurred trying to connect to web services.";
        
              this.openSnackBar(`Error ${statusCode}: ${errorMessage}`);
              console.error(`Error ${statusCode}`, error);
            },
          });
        } else {
          this.openSnackBar(response.message);
        }
      },
      error: (error) => {
        const statusCode = error.status;
        const errorMessage = error.error?.message || "An error occurred trying to connect to web services.";
  
        this.openSnackBar(`Error ${statusCode}: ${errorMessage}`);
        console.error(`Error ${statusCode}`, error);
      },
    });
  }  

  getStatesByCountry(countryId: number): void {
    this.apiStates.GetStatesByCountry(countryId).subscribe({
      next: (response) => {
        if (response.success === 1) {
          this.states = response.data;
        }else{
          this.openSnackBar(response.message);
        }
      },
      error: (error) => {
        const statusCode = error.status;
        const errorMessage = error.error?.message || "An error occurred trying to connect to web services.";
  
        this.openSnackBar(`Error ${statusCode}: ${errorMessage}`);
        console.error(`Error ${statusCode}`, error);
      },
    });
  }

  onCountryChange(countryId: number): void {
    this.Form.get('state_Id')?.reset();
    this.states = [];
    this.apiStates.GetStatesByCountry(countryId).subscribe({
      next: (response) => {
        if (response.success === 1) {
          this.states = response.data;
        }else{
          this.openSnackBar(response.message);
        }
      },
      error: (error) => {
        const statusCode = error.status;
        const errorMessage = error.error?.message || "An error occurred trying to connect to web services.";
  
        this.openSnackBar(`Error ${statusCode}: ${errorMessage}`);
        console.error(`Error ${statusCode}`, error);
      },
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    if (this.Form.valid) {
      this.dialogRef.close(this.Form.value);
    }
  }

  openSnackBar(Message: string) {
    this._snackBar.open(Message, "Dismiss", { duration: 5000 });
  }
}
